import React, { useState } from 'react';
import { useSessionStorage } from 'react-use';
import styled from 'styled-components';
import { LabelValue } from '../../../platform/types/LabelValue';
import { Colors, Input } from '../../../ui';
import { MenuButton } from '../../../ui/MenuButton';
import { Shadows } from '../../../ui/Standards';
import { SortMode } from '../../common/Sorter';
import { SortModeSelector } from '../../workspace/SortModeSelector';
import { Flexer, Title } from '../elements/LayoutElements';
import { MainBoardListView } from './MainBoardListView';

const sortOptions = [
    LabelValue('Last Visited', 'lastSeenAt'),
    LabelValue('Last Updated', 'updatedAt'),
    LabelValue('Date Created', 'createdAt'),
    LabelValue('Alphabetical', 'label'),
];


const Frame = styled.div`
    position: relative;
    border-radius: .5rem;
    padding: 1.5rem;
    /* box-shadow: ${Shadows.sm}; */
    border: solid 1px ${Colors.borderLight};
    background: white;
`;

export const RecentBoardsBrowser = () => {

    const [search, setSearch] = useState('');
    const [sort, setSort] = useSessionStorage('deqo/ui/recent/sort', ['lastSeenAt', 'desc'] as SortMode);

    const params = {
        // workspaceId: workspace.id,
        // folderId: !search?.trim() ? (folder?.id || 'root') : null,
        search: search?.trim() || '',
        sort,
    };

    return <Frame>
        <Flexer flex="row" align="center" justify="space-between">
            <Title flush size="3xl" weight="480" color={Colors.text}>Recent Boards</Title>
            <Flexer flex="row" align="center" gap="1">
                <Flexer width="16">
                    <Input autoFocus placeholder="Search" value={search} onChange={setSearch} />
                </Flexer>
                <Flexer width="9">
                    {!search && <SortModeSelector options={sortOptions} value={sort} onChange={setSort} />}
                    {!!search && <MenuButton block label="Relevance" disabled></MenuButton>}
                </Flexer>
            </Flexer>
        </Flexer>
        <Flexer height="1" />
        <MainBoardListView {...params} readonly options={{ showWorkspace: true }} />
    </Frame >;
};
